import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/user";
import api from "@/services/api";
import LayoutDefault from "../layouts/Default.vue";
import { startTokenRefresh } from "@/composables/useTokenRefresh";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
  routes: [
    // 登入
    {
      path: "/login",
      component: () => import("../views/auth/LoginView.vue"),
      meta: { requiresAuth: false },
    },
    // 忘記密碼
    {
      path: "/forget-pwd",
      component: () => import("../views/auth/ForgetPwdView.vue"),
      meta: { requiresAuth: false },
    },
    // 重設密碼
    {
      path: "/reset-pwd",
      component: () => import("../views/auth/ResetPwdView.vue"),
      meta: { requiresAuth: false },
    },

    // 首頁
    {
      path: "/",
      component: LayoutDefault,
      meta: { requiresAuth: true },
      children: [
        // 即時警示
        {
          path: "",
          component: () => import("../views/InstantAlertView.vue"),
        },
        {
          path: "instant-alert",
          component: () => import("../views/InstantAlertView.vue"),
        },
        // 實時監控
        {
          path: "real-time-monitoring",
          component: () => import("../views/RealTimeMonitoringView.vue"),
        },
        // 歷史資料 - 雷達
        {
          path: "history-data/radar",
          component: () => import("../views/HistoryRadarView.vue"),
        },
        // 歷史資料 - 攝影機
        {
          path: "history-data/camera",
          component: () => import("../views/HistoryCameraView.vue"),
        },
        // 圖表分析
        {
          path: "chart-analysis",
          component: () => import("../views/ChartAnalysisView.vue"),
        },
        // 參數設定（PS）
        // 2026-08-27 客戶確認不提供寫入 API（回覆「B，這次不做」），
        // 側邊選單入口已隱藏（見 AppSidebar.vue）；路由保留，直接輸入網址仍可檢視。
        {
          path: "settings",
          component: () => import("../views/SettingsView.vue"),
        },
      ],
    },
  ],
  // linkActiveClass: 'active',
  // linkExactActiveClass: 'active'
});

router.beforeEach(async (to, from, next) => {
  // 頁面是否需要驗證（子路由繼承父路由的 meta）
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth) {
    const user = useUserStore();
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      if (!user.isLogin) {
        try {
          await api.validateToken();
          // validate 回 204 No Content，token 有效即可
          user.isLogin = true;
          // 重新整理後仍在登入狀態時，一併恢復定期 token 更新
          startTokenRefresh();
        } catch (e) {
          // token 無效，導向登入頁
          localStorage.clear();
          next("/login");
          return;
        }
      }

      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
